export const Options = {
    Salutation: [
        { text: "männlich", value: "0" },
        { text: "weiblich", value: "1" },
        { text: "divers", value: "2" },
        { text: "unbekannt", value: "3" },
    ],
    BecomingAwareThrough: [
        { text: "Agentur für Arbeit", value: "Agentur für Arbeit" },
        { text: "Messeauftritte", value: "Messeauftritte" },
        { text: "Personaldienstleister", value: "Personaldienstleister" },
        { text: "Persönliche Empfehlung", value: "Persönliche Empfehlung" },
        { text: "Printmedien", value: "Printmedien" }, 
        { text: "Sonstige Internet-Plattformen", value: "Sonstige Internet-Plattformen" },
        { text: "Stepstone", value: "Stepstone" },
        { text: "TDK Homepage", value: "TDK Homepage" }, 
    ]
}
